'use strict';

import 'font-awesome/css/font-awesome.css';
import 'lodash';

// to support async/await
import "regenerator-runtime/runtime";
